import React from "react";
import classNames from "classnames";
import { Icon, Dropdown } from "components";
import styles from "./OfflineDropdown.module.css";

interface OfflineDropdownType {
  loading: boolean;
  progress: string;
  children: React.ReactNode;
}

const OfflineDropdown: React.FC<OfflineDropdownType> = ({
  loading,
  progress,
  children,
}) => {
  return (
    <Dropdown
      className={styles.wrapper}
      variant="clear"
      suffix={
        <div className={styles.iconWrapper}>
          <div
            className={classNames(styles.loading, {
              [styles.active]: loading,
            })}
          />
          <Icon
            name="cloud-download-outlined"
            size="small"
            className={styles.icon}
          />
        </div>
      }
      buttonClassName={(opened) =>
        classNames(styles.button, {
          [styles.opened]: opened,
          [styles.soft]: progress,
        })
      }
      contentContainerClassName={styles.contentWrapper}
      iconOnly={!progress}
      label={
        progress ? (
          <span className={styles.progressContainer}>{progress}</span>
        ) : (
          "Cached Assessments"
        )
      }
      position="right"
      size="small"
    >
      {() => children}
    </Dropdown>
  );
};

export default OfflineDropdown;
